import { render, staticRenderFns } from "./AdminAssessmentTemplatesView.vue?vue&type=template&id=6eb75317"
import script from "./AdminAssessmentTemplatesView.vue?vue&type=script&lang=ts"
export * from "./AdminAssessmentTemplatesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports